(ns basic-components.inputs.select
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.field :as field]
   [common.schema.registry :as registry]
   [frontend.components.open-search-select :as open-search-select]
   [frontend.logging :as logging]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.utils :as fu]
   [frontend.view.components.select :as select-comp]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.select-asset-type.view :as select-asset-type]
   [reagent.core :as r]
   [reagent.impl.component :as reagent-component]))

(defn keywordize
  [str-value]
  (let [res (if (= \: (first str-value))
              (keyword (subs str-value 1))
              (keyword str-value))]
    res))

(defn create-new-entity
  [{:keys [input-text entity-type attribute on-blur! on-change! clear-atom!
           mandatory-entity-fields]}]
  (f-entity/open-creator!
   entity-type
   {:named-value-attribute attribute
    :start-value           input-text
    :skip-success-msg?     true
    :mandatory-fields      mandatory-entity-fields
    :on-ok!                (fn [{:keys [new-entity-id close-cb!]}]
                             (try
                               (when on-change!
                                 (on-change! nil new-entity-id))
                               (if on-blur!
                                 (on-blur! nil new-entity-id clear-atom!)
                                 (clear-atom! nil))
                               (catch js/Object e
                                 (logging/error "Failed to create new entity : " e)))
                             (close-cb!))}))

(defn handle-new-option
  [{:keys [:new-option-text :on-blur! :clear-atom!]}]
  (on-blur! nil
            {:new-option new-option-text}
            ;; TODO: also close dropdown
            clear-atom!))

(defn coerce-select-value
  [value-type v]
  (case value-type
    :keyword (if (keyword? v)
               v
               (keywordize v))
    :string (if (string? v)
              v
              (str v))
    :number (if (number? v)
              v
              (when (re-matches #"\d+.?\d*" (str v)) (js/parseInt (str v))))
    :entity v
    (str v)))

(defn render-select
  [dom-atom args]
  (let [{:keys [is-multi
                value
                attribute
                containing-entity-type
                containing-entity
                value-type
                field/entity-types
                field/not-clearable?
                placeholder
                read-only? options
                on-blur! on-change!
                disabled?
                mandatory-entity-fields]}
        args
        entity-types (or entity-types
                         (:entity/type args))
        create-entity-types (field/create-entity-types args)
        creatable-entity-types (when create-entity-types
                                 (->> create-entity-types
                                      (remove (fn [et]
                                                ;;TODO should be updated to use a list of allowed entity-types.
                                                ;; likely solution: (-> common.schema.entity-types/entities :creatable-entity-types)
                                                ;; -note: it's missing at least named-value => won't use yet in case something else
                                                ;;        important is missing
                                                (some #{et}
                                                      [:entity.type/account
                                                       :entity.type/fund
                                                       :entity.type/team
                                                       :entity.type/webentry
                                                       ;; no longer explicit creation:
                                                       :entity.type/investor
                                                       :entity.type/kpi-category
                                                       :entity.type/pipeline])))))
        named-value-attribute (:named-value-attribute args)
        tenant-schema @session/tenant-schema
        edit-value (or (:temp-select-value @dom-atom)
                       value)
        clear-atom! (fn [_]
                      (swap! dom-atom dissoc :temp-select-value)

                      (deref dom-atom)                                                              ;; force sync
                      )
        on-change-select! (fn [selected-value]
                            (let [new-value (if is-multi
                                              (->> selected-value
                                                   (map (partial coerce-select-value value-type))
                                                   (remove nil?)
                                                   (set))
                                              (coerce-select-value value-type selected-value))]

                              (swap! dom-atom assoc :temp-select-value new-value)
                              (deref dom-atom)                                                      ;; force sync

                              (when on-change!
                                (on-change! nil new-value))
                              (when on-blur!
                                (on-blur! nil new-value clear-atom!))))
        create-new-entity!
        (fn [selected-entity-type input-text]

          (create-new-entity
           {:entity-type             selected-entity-type
            :attribute               named-value-attribute                                          ;;needed for named-values
            :input-text              input-text
            :on-blur!                (fn [e val clear-atom!]
                                       (let [refreshed-edit-value (or (:temp-select-value @dom-atom)
                                                                      value)
                                             new-val (if is-multi
                                                       (conj (or refreshed-edit-value #{}) val)
                                                       val)]
                                         (swap! dom-atom assoc
                                                :cache-version
                                                (inc (or (:cache-version @dom-atom)
                                                         0)))
                                         (deref dom-atom)                                           ;; force sync
                                         (when on-blur!
                                           (on-blur! e new-val clear-atom!))))
            :on-change!              (fn [e val]
                                       (let [refreshed-edit-value (or (:temp-select-value @dom-atom)
                                                                      value)
                                             new-val (if is-multi
                                                       (conj (or refreshed-edit-value #{}) val)
                                                       val)]
                                         (swap! dom-atom assoc :temp-select-value new-val)
                                         (deref dom-atom)                                           ;; force sync
                                         (when on-change!
                                           (on-change! e new-val))))
            :mandatory-entity-fields mandatory-entity-fields
            :clear-atom!             clear-atom!}))
        on-create-option!
        (fn [option-text]
          (let [old-value (or (:temp-select-value @dom-atom)
                              value)]
            (if (= value-type :entity)
              (if (= (count creatable-entity-types) 1)
                (create-new-entity! (first creatable-entity-types) option-text)
                (modals/open-modal!
                 select-asset-type/modal-key
                 {:allowed-asset-types creatable-entity-types
                  :modal-title         (or (->> attribute
                                                (registry/get-field-schema tenant-schema)
                                                :field/select-target-title
                                                :en)
                                           (loc/tr :select-type))
                  :select-label        (or (->> attribute
                                                (registry/get-field-schema tenant-schema)
                                                :field/select-target-label
                                                :en)
                                           (loc/tr :type))
                  :on-select!          (fn [selected-type close-modal!]
                                         (close-modal!)
                                         (create-new-entity! selected-type option-text))
                  :on-cancel!          (fn [_])}))
              (handle-new-option {:args        args
                                  :on-blur!    (fn [e nv clear-atom!]
                                                 (let [new-val (if is-multi
                                                                 (conj (or old-value #{}) nv)
                                                                 nv)]
                                                   (swap! dom-atom assoc
                                                          :cache-version
                                                          (inc (or (:cache-version @dom-atom)
                                                                   0)))
                                                   (deref dom-atom)                                 ;; force sync
                                                   (when on-blur!
                                                     (on-blur! e new-val clear-atom!))))
                                  :clear-atom! clear-atom!}))))
        common-props (merge {:value                  edit-value
                             :clearable              (not not-clearable?)
                             :cache-options          (or (:cache-version @dom-atom) true)
                             :placeholder            placeholder
                             :read-only?             (or read-only? (boolean disabled?))
                             :key                    (some-> args
                                                             :key-atom
                                                             deref
                                                             str)
                             :menu-placement         (or (:menu-placement args) "auto")
                             :on-change!             on-change-select!
                             :default-options        true
                             :filter-fn              (:field/option-filter-fn args)
                             :options                options
                             :entity-types           entity-types
                             :creatable-entity-types creatable-entity-types
                             :value-type             value-type
                             :named-value-attribute  named-value-attribute
                             :attribute              attribute
                             :entities-atom          session/entities}
                            (select-keys args
                                         [:is-multi
                                          :field/data-type
                                          :prompt-text-creator-keyword
                                          :close-menu-on-scroll?
                                          :menu-portal-target
                                          :field/custom-sort
                                          :max-opts-visible
                                          :force-opts-height?
                                          :on-focus!
                                          :debug?
                                          :refreshToken
                                          :filter-fn
                                          :entity-types-atom
                                          :menu-placement
                                          :match-any-word?
                                          :auto-focus
                                          :open-on-start?
                                          :on-menu-open!
                                          :on-menu-close!]))]
    (if
     (and
      (:create-on-fly? args)
      (let [can-create? (or (= attribute :oppo/target-asset)                                        ;; Kludge too tired to think this through
                            (= attribute :investor/legal-entity)
                            (and creatable-entity-types
                                 (= (count creatable-entity-types) 1)
                                 (case (first creatable-entity-types)
                                   :entity.type/company true
                                   :entity.type/real-estate true
                                   :entity.type/fof-asset true
                                   :entity.type/other-asset true
                                   :entity.type/person true
                                   :entity.type/investor true
                                   :entity.type/oppo (session/dealflow?)
                                   :entity.type/holding (session/portfolio?)
                                   :entity.type/fundraising-opportunity (session/fundraising?)
                                   false))
                            (f-permissions/field-option-create-access?
                             attribute
                             containing-entity-type
                             (fu/pipeline-id containing-entity)))]
        can-create?))
      [select-comp/select-creatable
       (merge common-props
              {:placeholder      (or placeholder (loc/tr :add-new-or-select))
               :on-create-option on-create-option!})]
      [select-comp/select common-props])))

(defmethod editor :editor.type/select
  [args]
  (let [dom-atom (r/atom nil)
        key-atom (r/atom (str (gensym "select-component")))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)
        use-ref-selector? (some #{(:field/data-type args)}
                                [:data.type/ref-multi :data.type/ref-single])]                      ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Select"
      :component-did-mount    (fn [_args]
                                (when set-focusable!
                                  (set-focusable! (fn [_]
                                                    (when-let [dom-node (:input-dom-node @dom-atom)]
                                                      (.focus dom-node)))))
                                (when set-cancel-edit!
                                  (set-cancel-edit! (fn [_]
                                                      (swap! dom-atom dissoc
                                                             :temp-select-value))))               ;; save complete -> reset temp state
                                (when set-save!
                                  (set-save! (fn [_]
                                               (when-let [dom-node (:input-dom-node @dom-atom)]
                                                 (.blur dom-node))))))
      :component-did-update   (fn [this old-argv]
                                (let [prev-props (reagent-component/extract-props old-argv)
                                      new-props (r/props this)
                                      prev-options (:options prev-props)
                                      new-options (:options new-props)
                                      old-value (:value prev-props)
                                      new-value (:value new-props)]
                                  (when (or (not= prev-options new-options)
                                            (not= old-value new-value))
                                    ;;force remount
                                    (reset! key-atom (str (gensym "select-component"))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (if use-ref-selector?
                                  (open-search-select/render-async-select-single args)
                                  (render-select dom-atom (assoc args :key-atom key-atom))))})))

(defmethod display-string :editor.type/select
  [args]
  (let [value (:value args)
        ;; Entity pages pass a ref-single value as the pulled entity map rather
        ;; than its id - normalize so both shapes resolve to a label.
        selected-entity (when (and (map? value) (:db/id value)) value)
        selected-id (if selected-entity (:db/id selected-entity) value)
        options (:options args)]
    (when selected-id
      (or (some->> options
                   (filter (fn [o] (= (:key o) selected-id)))
                   (first)
                   (:label))
          ;; ref-single fields resolve their options asynchronously (OpenSearch),
          ;; so `:options` never reaches here - resolve the entity label directly.
          (when (number? selected-id)
            (entity/display-string (or (session/get-entity selected-id)
                                       selected-entity)
                                   :long
                                   session/get-entity))))))

(defmethod viewer :editor.type/select
  [_args]
  (r/create-class
   {:display-name "select/viewer"
    :reagent-render
    (fn [args]
      (let [selected (:value args)
            component-id (:id args)
            attribute (:attribute args)
            options (:options args)
            selected-option (some->> options
                                     (filter (fn [o]
                                               (or (= (:key o) selected)
                                                   (= (:keyword o) selected))))
                                     (first))]
        [:div.preview.preview-select
         (if-not selected
           [:span {:key (str component-id "-comp-" attribute "-" selected)}
            "--"]
           (let [label (or (:label selected-option)
                           (when (number? selected)
                             (->> (get @session/entities selected)
                                  (entity/display-string)))
                           "--")
                 clickable? (and (number? selected)
                                 (let [entity-type (:entity/type (get @session/entities selected))]
                                   (some #{entity-type} routing/clickable-entity-types)))]
             (if clickable?
               [:span
                {:key      (str component-id "-comp-" attribute "-" selected)
                 :href     "#"
                 :on-click (fn [e]
                             (routing/open-entity selected)
                             (.preventDefault e))}
                label]
               [:span {:key (str component-id "-comp-" attribute "-" selected)}
                label])))]))}))
